export const filter = (
  item: any,
  isPlayground?: boolean,
  isPayingCustomer?: boolean,
  isEmployee?: boolean
) => {
  let output = true;

  const { flavour } = item;

  switch (flavour) {
    case 'hidden':
      output = false;
      break;
    case 'free':
      output = isPayingCustomer === true;
      break;
    case 'playground':
      output = isPlayground === true;
      break;
    case 'sloyd-only':
      output = isEmployee === true;
      break;
  }

  return output;
};
